module.exports = __webpack_public_path__ + "img/sousuo.3183f173.png";